import { darken, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { TextButtonColor } from './text-button.component';
import { Colors } from '../../../theme/colors';

export const useTextButtonStyles = makeStyles<Theme, { color: TextButtonColor; fontSize?: string; fontColor?: string }>(
  () => ({
    root: {
      fontSize: ({ fontSize = '14px' }) => fontSize,
      marginTop: '2px'
    },
    button: {
      borderColor: (props) => props.fontColor ?? colorMap[props.color],
      color: (props) => props.fontColor ?? colorMap[props.color],
      position: 'relative' as const
    },
    // MUI only fills a contained button from the theme palette, and the colour here never reaches it.
    contained: {
      color: (props) => props.fontColor ?? '#ffffff',
      backgroundColor: (props) => colorMap[props.color],
      '&:hover': {
        backgroundColor: (props) => darken(colorMap[props.color], 0.15)
      }
    },
    spinner: {
      position: 'absolute' as const,
      color: 'inherit'
    }
  })
);

const colorMap: Record<TextButtonColor, string> = {
  danger: Colors.cancelledDeletedRed,
  primary: Colors.collectedGreen,
  secondary: Colors.midDarkGray
};
